/**
 * WebSocket connection states
 */
export type WebSocketConnectionState = 'disconnected' | 'connecting' | 'connected' | 'error';

/**
 * Video conversion status
 */
export interface VideoConversionStatus {
    uuid: string;
    success: boolean;
    timestamp: number;
}

/**
 * Message format for WebSocket actions
 */
export type VideoConversionMessage =
    | { action: 'send-video-conversion-uuid'; uuid: string }
    | { action: 'view-page'; page: string }
    | { action: SocketActions.RASPI_CONTENTS_UPDATE; licenseId: string }
    | { action: SocketActions.RASPI_CONNECT; licenseId: string; serialKey: string }
    | { action: SocketActions.RASPI_REBOOT; licenseId: string };

/**
 * Response format from WebSocket server
 */
export interface VideoConversionResponse {
    Success?: boolean;
    success?: boolean;
    IsConverted?: boolean;
    isConverted?: boolean;
    uuid?: string;
    /** ContentId of the content that finished converting (alternate to uuid) */
    ContentId?: string;
    contentId?: string;
}

/**
 * Socket list of allowed actions
 */
export enum SocketActions {
    RASPI_CONNECT = 'raspi-connect',
    RASPI_REBOOT = 'raspi-reboot',
    RASPI_CONTENTS_UPDATE = 'raspi-contents-update',
}
